// Constants for question counts
export const PART_A_COUNT = 10;
export const PART_B_COUNT = 15;
export const TOTAL_QUESTIONS = PART_A_COUNT + PART_B_COUNT; // 25

// Part A: 10 Multiple-Choice Questions
export const partAQuestions = [
  {
    type: 'multiple-choice',
    id: 1,
    question: "When a new ministry idea comes up, I first think:",
    options: {
      A: { text: "Big picture / future impact", archetype: "visionary" },
      B: { text: "People needs & pastoral care", archetype: "shepherd" },
      C: { text: "Plan, budget, timeline", archetype: "organizer" },
      D: { text: "How we'll invite + mobilize people", archetype: "evangelist" }
    }
  },
  {
    type: 'multiple-choice',
    id: 2,
    question: "In team meetings, I'm usually the one who:",
    options: {
      A: { text: "Pushes vision + innovation", archetype: "visionary" },
      B: { text: "Senses the room + supports people", archetype: "shepherd" },
      C: { text: "Clarifies next steps + owners", archetype: "organizer" },
      D: { text: "Energizes + recruits help", archetype: "evangelist" }
    }
  },
  {
    type: 'multiple-choice',
    id: 3,
    question: "A Sunday goes sideways. I naturally:",
    options: {
      A: { text: "Reframe + adjust strategy", archetype: "visionary" },
      B: { text: "Encourage the team + check hearts", archetype: "shepherd" },
      C: { text: "Diagnose what broke + prevent it", archetype: "organizer" },
      D: { text: "Jump in and do whatever's needed", archetype: "servant" }
    }
  },
  {
    type: 'multiple-choice',
    id: 4,
    question: "I feel most alive when I'm:",
    options: {
      A: { text: "Building something new", archetype: "visionary" },
      B: { text: "Caring for someone 1:1", archetype: "shepherd" },
      C: { text: "Teaching / mentoring / explaining", archetype: "teacher" },
      D: { text: "Meeting people + connecting them", archetype: "evangelist" }
    }
  },
  {
    type: 'multiple-choice',
    id: 5,
    question: "If someone is struggling on staff, I'm most likely to:",
    options: {
      A: { text: "Listen, pray, support", archetype: "shepherd" },
      B: { text: "Help clarify expectations + plan", archetype: "organizer" },
      C: { text: "Quietly lighten their load", archetype: "servant" },
      D: { text: "Encourage them with purpose + direction", archetype: "visionary" }
    }
  },
  {
    type: 'multiple-choice',
    id: 6,
    question: "My ideal workday looks like:",
    options: {
      A: { text: "Structured, clear tasks, steady progress", archetype: "organizer" },
      B: { text: "Lots of conversations + momentum", archetype: "evangelist" },
      C: { text: "Deep focus time to learn/build content", archetype: "teacher" },
      D: { text: "Flexible—help wherever needed", archetype: "servant" }
    }
  },
  {
    type: 'multiple-choice',
    id: 7,
    question: "When decisions are stuck, I tend to:",
    options: {
      A: { text: "Cast a direction and move", archetype: "visionary" },
      B: { text: "Seek alignment and unity first", archetype: "shepherd" },
      C: { text: "Ask for data, options, and a process", archetype: "organizer" },
      D: { text: "Get feedback from people quickly and act", archetype: "evangelist" }
    }
  },
  {
    type: 'multiple-choice',
    id: 8,
    question: "In conflict, my instinct is:",
    options: {
      A: { text: "Restore relationships + understanding", archetype: "shepherd" },
      B: { text: "Clarify roles/rules and resolve", archetype: "organizer" },
      C: { text: "Refocus everyone on mission", archetype: "visionary" },
      D: { text: "Support quietly / avoid spotlight", archetype: "servant" }
    }
  },
  {
    type: 'multiple-choice',
    id: 9,
    question: "I prefer to influence others by:",
    options: {
      A: { text: "Clear reasoning + teaching", archetype: "teacher" },
      B: { text: "Enthusiasm + invitation", archetype: "evangelist" },
      C: { text: "Empathy + trust", archetype: "shepherd" },
      D: { text: "Structure + accountability", archetype: "organizer" }
    }
  },
  {
    type: 'multiple-choice',
    id: 10,
    question: "If you gave me a blank slate for a month, I'd:",
    options: {
      A: { text: "Launch or redesign something major", archetype: "visionary" },
      B: { text: "Create a training / discipleship track", archetype: "teacher" },
      C: { text: "Run outreach/connection campaigns", archetype: "evangelist" },
      D: { text: "Improve systems + operations", archetype: "organizer" }
    }
  }
];

// Part B: 15 Rating Scale Questions (1-5)
export const partBQuestions = [
  { type: 'rating', id: 11, statement: "I naturally think in 'what could be' more than 'what is.'", archetype: "visionary" },
  { type: 'rating', id: 12, statement: "I'm highly aware of how people are doing emotionally/spiritually.", archetype: "shepherd" },
  { type: 'rating', id: 13, statement: "I like clear plans, checklists, and predictable systems.", archetype: "organizer" },
  { type: 'rating', id: 14, statement: "Meeting new people energizes me.", archetype: "evangelist" },
  { type: 'rating', id: 15, statement: "I love explaining complex ideas simply.", archetype: "teacher" },
  { type: 'rating', id: 16, statement: "I'm happiest serving behind the scenes without recognition.", archetype: "servant" },
  { type: 'rating', id: 17, statement: "I get restless when we maintain the status quo too long.", archetype: "visionary" },
  { type: 'rating', id: 18, statement: "I'll pause my work to care for someone who's hurting.", archetype: "shepherd" },
  { type: 'rating', id: 19, statement: "I notice details others miss and feel responsible to fix them.", archetype: "organizer" },
  { type: 'rating', id: 20, statement: "I'm comfortable making 'the ask' (invite, recruit, fundraise).", archetype: "evangelist" },
  { type: 'rating', id: 21, statement: "I'm drawn to studying scripture/leadership deeply and sharing it.", archetype: "teacher" },
  { type: 'rating', id: 22, statement: "I naturally step in when something practical needs doing.", archetype: "servant" },
  { type: 'rating', id: 23, statement: "I'm willing to take calculated risks if the mission is clear.", archetype: "visionary" },
  { type: 'rating', id: 24, statement: "Last-minute changes stress me more than they stress most people.", archetype: "organizer" },
  { type: 'rating', id: 25, statement: "My strongest contribution is often helping people feel seen and safe.", archetype: "shepherd" }
];

// Create a mixed sequence: alternating MCQ and Rating for variety
export const mixedQuestions = [
  partAQuestions[0],  // MCQ 1
  partBQuestions[0],  // Rating 11
  partAQuestions[1],  // MCQ 2
  partBQuestions[1],  // Rating 12
  partBQuestions[2],  // Rating 13
  partAQuestions[2],  // MCQ 3
  partBQuestions[3],  // Rating 14
  partAQuestions[3],  // MCQ 4
  partBQuestions[4],  // Rating 15
  partBQuestions[5],  // Rating 16
  partAQuestions[4],  // MCQ 5
  partBQuestions[6],  // Rating 17
  partAQuestions[5],  // MCQ 6
  partBQuestions[7],  // Rating 18
  partBQuestions[8],  // Rating 19
  partAQuestions[6],  // MCQ 7
  partBQuestions[9],  // Rating 20
  partAQuestions[7],  // MCQ 8
  partBQuestions[10], // Rating 21
  partBQuestions[11], // Rating 22
  partAQuestions[8],  // MCQ 9
  partBQuestions[12], // Rating 23
  partAQuestions[9],  // MCQ 10
  partBQuestions[13], // Rating 24
  partBQuestions[14], // Rating 25
];

// Legacy exports for backwards compatibility
export const sortedPartBQuestions = partBQuestions;
